import AuthLayout from '@/components/auth/AuthLayout'
import LoginHeader from '@/components/auth/login/Header'
import GoogleLoginSection from '@/components/auth/login/GoogleLoginSection'
import styled from '@emotion/styled'
import { Text } from '@collable/ui'
import usePageView from '@/hooks/logging/usePageView'

const Login = () => {
  usePageView('creator_view_login_page')

  return (
    <AuthLayout headerButton="back">
      <LoginHeader />
      <GoogleLoginSection />
      <CreatorLink href="https://collable.co">
        <Text size="body2" color="labelAlternative">
          광고대행사 및 프리랜서인가요?
        </Text>
      </CreatorLink>
    </AuthLayout>
  )
}

export default Login

const CreatorLink = styled.a`
  color: ${({ theme }) => theme.label.labelAlternative};
  padding: 4px 8px;
  letter-spacing: -0.32px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`
